import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'filter',
})
export class FilterPipe implements PipeTransform {
	public transform(items: any[] = [], term, type = 'users'): any {
		if (!items) {
			return items;
		}
		if (type === 'users') {
			return term
				? items.filter(item => {
					const fullname = item.first_name + ' ' + item.last_name;

					return fullname.toLowerCase().indexOf(term.toLowerCase()) !== -1;
				})
				: items;
		} else if (type === 'groups') {
			return term
				? items.filter(item =>
					item.group_name.toLowerCase().indexOf(term.toLowerCase()) !== -1)
				: items;
		} else if (type === 'salary-overview') {
			return term
				? items.filter(item =>
					(item.user.first_name + ' ' + item.user.last_name).toLowerCase().indexOf(term.toLowerCase()) !== -1)
				: items;
		}

	}
}
